import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ControllerForViewBase } from '../framework/controller-for-view-base';
import { PageContainerService } from '../../services';
import { faChevronLeft, faChevronRight, faPenAlt } from '@fortawesome/free-solid-svg-icons';
import {
  ProjectDto,
  ClientDto,
  ReadinessSummaryDto,
  ModuleDisplaySettingDto,
  GetReadinessSummaryCommandRequest,
  GetReadinessSummaryCommandResponse,
  MaterialsStageStatusDto,
  GetMaterialsStatusCommandRequest,
  GetMaterialsStatusCommandResponse,
  ExecutionSummaryDto,
  GetExecutionStatusCommandRequest,
  GetExecutionStatusCommandResponse,
  ExecutionScheduleDto,
  ExecutionChartDataDto,
  GetExecutionChartCommandRequest,
  GetExecutionChartCommandResponse,
  //GetExecutionBarChartCommandRequest,
  //GetExecutionBarChartCommandResponse,
  //ExecutionChartDataSeriesDto,
  GetExecutionCurrentStatusChartCommandRequest,
  GetExecutionCurrentStatusChartCommandResponse,
  ExecutionBarChartDto,
  GetProjectModuleDisplaySettingsCommandRequest,
  GetProjectModuleDisplaySettingsCommandResponse,
  SummaryStageDto,
  StageDto,
  GetProjectSetupCommandRequest,
  GetProjectSetupCommandResponse,
  GetExecutionBarChartCommandRequest,
  GetExecutionBarChartCommandResponse,
  ExecutionChartDataSeriesDto,
  ProjectSetupDto,
  UserRoleDto
} from "../../data/CommandServiceDtos.generated";

@Component({
  selector: 'project-summary',
  templateUrl: './project-summary.component.html',
  styleUrls: ['./project-summary.component.scss']
})
export class ProjectSummaryComponent extends ControllerForViewBase implements OnInit {
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPencil = faPenAlt;
  project: ProjectSetupDto = new ProjectSetupDto;
  projectId: number;
  powerBiReportPath: string;
  projectDisplayType: string;
  executionComplete: number = 35;
  readinessSummary: ReadinessSummaryDto;
  materialsSummary: MaterialsStageStatusDto;
  executionSummary: ExecutionSummaryDto;
  executionChartData: ExecutionChartDataDto[];
  executionBarChartData: ExecutionChartDataSeriesDto[];
  executionLineChartData: ExecutionBarChartDto;
  moduleDisplaySetting: ModuleDisplaySettingDto;
  cxPlannerSummary: boolean = false;
  cxPlannerSummaryStage: any//SummaryStageDto;
  currentSlideIndex = 0;
  totalSlides = 0;
  userRoles: UserRoleDto[];
  showEditIconForUser: boolean = false;
  constructor(
    public pcs: PageContainerService,
    private route: ActivatedRoute) {
    super(pcs);
  }

  ngOnInit() {
    this.projectId = +this.route.snapshot.paramMap.get('id');

    console.log("In ProjectSummaryComponent - ngOnInit(), for project id: " + this.projectId);
    this.getModuleDisplaySettings(this.projectId).then(data => {

      if (this.moduleDisplaySetting.DisplayReadiness) {
        this.loadReadinessData(this.projectId);
      } else {
        console.log("In ProjectSummaryComponent - ngOnInit(), system found display readiness: false.");
      }

      if (this.moduleDisplaySetting.DisplayMaterials) {
        this.loadMaterialsData(this.projectId);
      }

      if (this.moduleDisplaySetting.DisplayExecution) {
        this.loadExecutionData(this.projectId);
        this.loadExecutionStatusChartData(this.projectId);
        // this.loadExecutionBarChartData(this.projectId);
      }

      this.loadProjectData(this.projectId);
    });


    /*    
        if (this.moduleDisplaySetting.DisplayReadiness) {
          this.loadReadinessData(id);
        }
    
        if (this.moduleDisplaySetting.DisplayMaterials) {
          this.loadMaterialsData(id);
        }
        if (this.moduleDisplaySetting.DisplayExecution) {
          this.loadExecutionData(id);
          this.loadExecutionStatusChartData(id);
        }
    */
    //this.loadExecutionChartData(id);
    //this.loadExecutionBarChartData(id);


  }

  async getModuleDisplaySettings(id: number) {
    let payload: GetProjectModuleDisplaySettingsCommandRequest = { ProPakProjectId: id }
    const response: GetProjectModuleDisplaySettingsCommandResponse = await this.pcs.apiService.GetProjectModuleDisplaySettings(payload, false, false);
    this.moduleDisplaySetting = response.ModuleDisplaySettings;
  }

  async loadReadinessData(id: number) {
    console.log("In ProjectSummaryComponent - loadReadinessData(), system will attempt to populate readiness summary.");

    let payload: GetReadinessSummaryCommandRequest = { ProjectId: id, ProPakProjectId: id }
    const response: GetReadinessSummaryCommandResponse = await this.pcs.apiService.GetReadinessSummary(payload, false, false);

    if (response.ReadinessSummary.Priorities.length > 0) {
      for (let priority of response.ReadinessSummary.Priorities) {
        if (priority.TaskCountTotal > 0) {
          console.log("In ProjectSummaryComponent - loadReadinessData(), system will populate readiness summary.");

          // Commented by Haroon on 18th April 2024
          // this.project = response.ReadinessSummary.Project;
          this.totalSlides++;
          this.readinessSummary = response.ReadinessSummary;

          break;
        }
      }
    } else {
      console.log("In ProjectSummaryComponent - loadReadinessData(), system could not find any priorities for readiness.");
    }
  }

  async loadMaterialsData(id: number) {
    let payload: GetMaterialsStatusCommandRequest = { ProjectId: id }
    const response: GetMaterialsStatusCommandResponse = await this.pcs.apiService.GetMaterialsStatus(payload, false, false);
    if (response.Materials.MaterialsAccessUrl != null && response.Materials.MaterialsSchemas.length != 0) {
      this.materialsSummary = response.Materials;
      this.totalSlides++;
    }
  }

  async loadExecutionData(id: number) {
    let payload: GetExecutionStatusCommandRequest = { ProjectId: id }
    const response: GetExecutionStatusCommandResponse = await this.pcs.apiService.GetExecutionStatus(payload, false, false);
    this.executionSummary = response.Execution;
    this.totalSlides++;
  }

  async loadExecutionChartData(id: number) {
    let payload: GetExecutionChartCommandRequest = { ProjectId: id, StartDate: null, EndDate: null }
    const response: GetExecutionChartCommandResponse = await this.pcs.apiService.GetExecutionChart(payload, false, false);
    this.executionChartData = response.Data.ChartData;
  }


  async loadExecutionBarChartData(id: number) {
    let payload: GetExecutionBarChartCommandRequest = { ProjectId: id }
    const response: GetExecutionBarChartCommandResponse = await this.pcs.apiService.GetExecutionBarChart(payload, false, false);
    this.executionBarChartData = response.Data;
  }

  async loadExecutionStatusChartData(id: number) {
    let payloadStatusChart: GetExecutionCurrentStatusChartCommandRequest = { ProjectId: id }
    let responseStatusChart: GetExecutionCurrentStatusChartCommandResponse = await this.pcs.apiService.GetExecutionCurrentStatusChart(payloadStatusChart, true, false);
    this.executionLineChartData = responseStatusChart.Data;
  }

  clientLogo(client: ClientDto) {
    if (!this.project.ProPakProject.Client.hasOwnProperty('logo'))
      return 'app/assets/images/project-placeholder.png';

    return '';
  }

  private transformData(dataArray: any[]): any[] {
    return dataArray.map((data) => {
      return {
        SummaryStageId: data.id,
        StageName: data.name,
        PercentComplete: data.sub_per,
        Stages: data.children ? data.children.map((child: any): any => ({
          StageId: child.id,
          StageName: child.name,
          PercentComplete: child.sub_per
        })) : []
      };
    });
  }

  // Added by Haroon on 18th April 2024
  async loadProjectData(projectId) {
    const request: GetProjectSetupCommandRequest = { ProjectId: projectId }
    const response: GetProjectSetupCommandResponse = await this.pcs.apiService.GetProjectSetup(request, true, false);
    this.project = response.ProjectInfo;
    this.powerBiReportPath = response.ProjectInfo.PowerBiReportPath;
    this.projectDisplayType = response.ProjectInfo.ProjectDisplayType;
    this.userRoles = response.ProjectInfo.UserRoles;
    this.showEditIconForUser = this.userRoles.some(role =>
      role.RoleName === 'Global Administrator' ||
      role.RoleName === 'Company Administrator' ||
      role.RoleName === 'Project Manager'
    );
    if (this.moduleDisplaySetting.DisplayExecution && this.projectDisplayType.includes('scurve'))
      this.loadExecutionChartData(this.projectId);

    if (response.ProjectInfo.CXPlannerIdentifiers.length > 0)
      this.pcs.apiService.executeCommandService.getCxPlanner(response.ProjectInfo.CXPlannerIdentifiers[0]).then((data) => {
        this.cxPlannerSummary = true;
        this.cxPlannerSummaryStage = this.transformData(JSON.parse(data._body));
        this.cxPlannerSummaryStage.projectId = response.ProjectInfo.CXPlannerIdentifiers[0];
        this.totalSlides++;
      });
  }

  moveLeft() {
    if (this.currentSlideIndex > 0) {
      this.currentSlideIndex--;
    }
  }

  moveRight() {
    if (this.currentSlideIndex < this.totalSlides - 3) {
      this.currentSlideIndex++;
    }
  }

  getTransform() {
    return `translateX(-${this.currentSlideIndex * 33.3333}%)`;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/project-summary/project-summary.component.ts